/**
 * Selected-state indicator — a subtle left accent bar. THE single canonical
 * "this item is selected" affordance across every app (console sidebar, hosted,
 * internal, `StatCell` filter tiles, any selectable surface). Lives in shared so
 * all three apps render the identical bar — never re-roll a local variant.
 *
 * SIZELESS core (position + width + color only). Each consumer adds the
 * HEIGHT/inset that fits its container:
 *   - small icon (sidebar):    cn(SELECTION_BAR, 'top-1/2 -translate-y-1/2 h-3')
 *   - a taller card (StatCell): cn(SELECTION_BAR, 'inset-y-1.5')  // spans the tile
 *
 * Render it as an absolutely-positioned child of a `relative` container:
 *   <div className="relative ...">
 *     {selected && <span aria-hidden className={cn(SELECTION_BAR, '<sizing>')} />}
 *     ...
 *   </div>
 */
export const SELECTION_BAR = 'absolute left-0 w-0.5 rounded-full bg-primary';
